import axios from "axios";
import { Env, MultiClient } from "config";
import OMNIX_MODULE from "constants/OMNIX_MODULE";
import { SIMO_VAR } from "constants/APP_CONSTANTS";

const buildUrl = (group: OMNIX_MODULE) => {
  const _process = process.env;
  const [_client, _env] = MultiClient.get_user_env(
    null,
    Env.clients,
    Env.env,
    Env.defaults
  );
  const env = _env?.toUpperCase();
  const currentWebsite = _client?.toUpperCase();
  const urlBase = _process[`REACT_APP_BASE_${env}_URL_${currentWebsite}`];
  const urlGroup = _process[`REACT_APP_API_URL_${group.toUpperCase()}`];
  console.log(`${urlBase}-${urlGroup}`)
  return `${urlBase}-${urlGroup}`;
};

const addUserContextInterceptor = (axiosInstance: any) => {
  axiosInstance.interceptors.request.use(
    (config: any) => {
      const userDataStr = localStorage.getItem(SIMO_VAR);
      if (userDataStr) {
        try {
          const userData = JSON.parse(userDataStr);
          if (userData.context) {
            config.headers['X-User-Context'] = userData.context;
          }
        } catch (error) {
          console.error('Error parsing user data from localStorage:', error);
        }
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );
};

export const axiosClientOSM = axios.create({
  baseURL: buildUrl(OMNIX_MODULE.OSM),
});
addUserContextInterceptor(axiosClientOSM);

export const axiosClientOOM = axios.create({
  baseURL: buildUrl(OMNIX_MODULE.OOM),
});
addUserContextInterceptor(axiosClientOOM);

export const axiosClientOIM = axios.create({
  baseURL: buildUrl(OMNIX_MODULE.OIM),
});
addUserContextInterceptor(axiosClientOIM);

export const axiosClientOLM = axios.create({
  baseURL: buildUrl(OMNIX_MODULE.OLM),
});
addUserContextInterceptor(axiosClientOLM);

export const axiosClientDOWNLOAD = axios.create({
  baseURL: buildUrl(OMNIX_MODULE.DOWNLOAD),
});
addUserContextInterceptor(axiosClientDOWNLOAD);

export const axiosClientOSRM = axios.create({
  baseURL: buildUrl(OMNIX_MODULE.OSRM),
});
addUserContextInterceptor(axiosClientOSRM);

export const axiosClientMiddleware = axios.create({
  baseURL: buildUrl(OMNIX_MODULE.MIDDLEWARE),
});
addUserContextInterceptor(axiosClientMiddleware);

// export const axiosClientPRIORITIZATION = axios.create({
//   baseURL: buildUrl(OMNIX_MODULE.PRIORITIZATION),
// });
